import React from 'react';

interface AiLoaderProps {
  className?: string;
  icon: string;
  name: string;
}

export const AiLoader: React.FC<AiLoaderProps> = ({
  className = '',
  icon,
  name,
}) => {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 bg-black/70 ${className}`}
    >
      <div className="bg-[#232323] rounded-2xl px-12 py-10 flex flex-col items-center min-w-[400px] min-h-[250px] shadow-lg">
        <img
          src={icon}
          alt={`${name} Icon`}
          className="mb-8 mt-2"
          style={{ width: 48, height: 48 }}
        />
        <div className="w-full flex items-center mb-8">
          <div className="h-1 w-full bg-[#3A362D] rounded-full overflow-hidden">
            <div
              className="h-1 bg-[#FEC200] rounded-full animate-loading"
              style={{
                width: '100%',
                transform: 'translateX(-100%)',
              }}
            ></div>
          </div>
        </div>
        <div className="text-white text-lg font-medium text-center">
          Génération {name} en cours
        </div>
      </div>
    </div>
  );
};

const styles = `
@keyframes loading {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.animate-loading {
  animation: loading 1.5s ease-in-out infinite;
}
`;

if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}
